import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuEntries } from 'lib/enums';

export function useTitle(title: MenuEntries): ReactElement {
  const { t } = useTranslation('menu');
  return <title>ASTJ | {t(title)}</title>;
}
